<template>
  <!-- 看板 -->
  <div class="authorization">
    <div class="top_center">
      <div class="top flex">
        <div class="top_tit flex">
          <!-- <img src="https://images.amazon.com/images/P/B000WPBOHQ.jpg" @load="handleError('https://images.amazon.com/images/P/B000WPBOHQ.jpg')" /> -->
          <div class="top_tit_left flex">
            <div class="le_cen">

              <div class="top_tit_left_top">
                <p style="font-size:20px;" class="p1">高效管理联盟营销平台</p>
                <p style="font-size:14px" class="p2">授权连接多个联盟平台，自动化获取数据，生成简单易</p>
                <p style="font-size:14px">懂的可视化报告，帮助你高效管理分销项目和决策。</p>
              </div>
              <div class="top_tit_left_bott flex">
                <div v-for="(item, index) in queryPlatformListList" :key="index" @click="switchpt(item, index)"
                  class="avanlink" style="border: none">
                  <div class="avanlink_li">
                    <div class="gg ru50"
                      v-if="item.platformCode == 'avantLink' || item.platformCode == 'shareASale' || item.platformCode == 'impact'">
                      <div v-if="avtiStuts == index" class="correct ru50"></div>
                    </div>
                    <div class="flex login_top">
                      <div class="login">
                        <img :src="item.platformLogo" alt="">
                      </div>
                    </div>
                    <div style="font-size:16px;" class="nmae">
                      {{ item.platformName }}
                    </div>
                    <div class="bott center w100 co5a">
                      <span v-if="item.list.length" style="font-size:12px;" class="cursor">查看详情</span>
                      <span v-else style="font-size:12px;" class="cursor">授权</span>
                    </div>
                  </div>
                  <div class="co00ds flex"
                    v-if="item.platformCode != 'avantLink' && item.platformCode != 'shareASale' && item.platformCode != 'impact'">
                    <i class="el-icon-lock"></i>
                  </div>
                </div>
                <div class="avanlink" style="opacity: 0;">
                  <div class="avanlink_li">
                    <div class="gg ru50">
                      <div class="correct ru50"></div>
                    </div>
                    <div class="flex login_top">
                      <div class="login">

                      </div>
                    </div>
                    <div style="font-size:16px;" class="nmae">

                    </div>
                    <div class="bott center w100 co5a">
                      <span style="font-size:12px;" class="cursor">查看详情</span>
                      <span style="font-size:12px;" class="cursor">授权</span>
                    </div>
                  </div>
                  <div class="co00ds flex">
                    <i class="el-icon-lock"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="top_tit_right">
            <img src="@/assets/img/platform/y.png" alt="">
          </div> -->
        </div>
        <div class="drawer_center">
          <el-drawer title="" :visible.sync="drawer" direction="rtl" :size="widthSize" :before-close="handleCloses"
            :modal="false">
            <div class="drawer_top">
              <div style="font-size:20px;" class="font_bo">{{ nametype }} 授权</div>
              <div v-if="platformCode == 'avantLink' || platformCode == 'shareASale'" class="co5a titletext cursor"
                @click="configure">点击跳转查看配置信息指引教程</div>
            </div>
            <div class="drawer_text w100 mb10">
              <div class="drawer_form w100">
                <div v-if="tabstuts" class="mb10">您已经授权过该平台</div>
                <div class="mb60">
                  <div class="co70">Merchant ID*</div>
                  <div class="drawer_input">
                    <input style="width:500px;" type="text" v-model="merchantId" placeholder="商家会员ID">
                  </div>
                </div>
                <div class="mb60" v-if="apiTokenState">
                  <div class="co70">Token*</div>
                  <div class="drawer_input">
                    <input style="width:500px;" type="text" v-model="apiToken" placeholder="API 凭证">
                  </div>
                </div>
                <div v-if="authKeyState">
                  <div class="co70">API Key*</div>
                  <div class="drawer_input">
                    <input style="width:500px;" type="text" v-model="authKey" placeholder="API 授权码">
                  </div>
                </div>
                <div v-if="apiSecretState">
                  <div class="co70">API Secret*</div>
                  <div class="drawer_input">
                    <input style="width:500px;" type="text" v-model="apiSecret" placeholder="API 密钥">
                  </div>
                </div>
                <div v-if="impactState">
                  <div class="co70">Token*</div>
                  <div class="drawer_input">
                    <input style="width:500px;" type="text" v-model="impactAuthKey" placeholder="API 凭证">
                  </div>
                </div>
                <div v-if="!tabstuts" class="drawer_bott center ru5 ba6e coff cursor" @click="testclick">授权</div>
                <el-button v-else disabled class="drawer_el_bott center ru5 cursor ba70 co00" :loading="showloading"
                  @click="testclick">授权</el-button>
              </div>
            </div>
            <div v-if="stutmsg == 1">
              <div class="drastuts w100 flex mb20">
                <div class="cc"></div>
              </div>
              <div class="drastuts w100 flex">
                <div style="font-size:12px;">授权成功，请前往素材管理进行下一步操作</div>
              </div>
            </div>
            <div v-if="stutmsg == 2">
              <div class="drastuts w100 flex mb20">
                <div class="dd"></div>
              </div>
              <div class="drastuts w100 flex">
                <div style="font-size:12px;">授权失败，请核对您填写的信息</div>
              </div>
            </div>
          </el-drawer>
        </div>
      </div>
    </div>
    <!-- <icp></icp> -->
  </div>
</template>
<script>
import { AUTH, QUERYPLATFORMLIST } from '../../api/platform'
import icp from '../icp/icp.vue'
import { setLocaData, getLocaData } from '@/utils/common'
export default {
  components: {
    icp
  },
  data() {
    return {
      validParam: localStorage.getItem('validParam'),
      avtiStuts: 0,
      apiTokenState: false,
      authKeyState: false,
      apiSecretState: false,
      impactState: false,
      drawer: false,
      tabstuts: false,
      widthSize: '50%',
      showloading: false,
      zkstyts: 1,
      nametype: '',
      // authType:'', //平台类型ShareASale/AvantLink
      merchantId: '', // 商户号
      authKey: '', //身份key 仅AvantLink需要
      apiToken: '', // 身份token 仅ShareASale需要
      apiSecret: '',// 身份密钥 仅ShareASale需要
      impactAuthKey: '',
      stutmsg: 0,
      queryPlatformListList: [], // 授权列表
      platformCode: '',
      platformName: '',
    }
  },
  mounted() {
    if (this.validParam !== 'sqzx') {
      this.$bus.$emit('showNopermiss', true)
      return
    }
    this.queryPlatformListmap()
  },
  computed: {
    bootstuts() {
      if (this.avtiStuts == 1) {
        return !!this.merchantId && !!this.authKey
      } else {
        return !!this.merchantId && !!this.apiToken && !!this.apiSecret
      }
    }
  },
  methods: {
    queryPlatformListmap() {
      QUERYPLATFORMLIST().then(res => {
        this.queryPlatformListList = res.data.body
      })
    },
    switchpt(e, index) {
      this.isLockFlag = '1'
      let tempList = getLocaData('permitList')
      tempList.forEach(item => {
        if (item.code === 'platform_manage') {
          item.permits.forEach(item2 => {
            if (item2.code === 'auth_center') {
              this.isLockFlag = item2.isLock
            }
          })
        }
      })
      if (this.isLockFlag === '1') {
        this.$bus.$emit('showNopermiss', true)
      } else {
        this.platformName = e.platformName
        this.platformCode = e.platformCode
        this.avtiStuts = index
        if (e.platformCode == 'avantLink' || e.platformCode == 'shareASale' || e.platformCode == 'impact') {
          this.drawer = true
        } else {
          this.drawer = false
        }

        this.stutmsg = 0
        this.nametype = e.platformName
        if (e.list.length) {
          this.tabstuts = true
        } else {
          this.tabstuts = false
        }

        if (e.platformName == 'AvantLink') {
          this.apiTokenState = false
          this.authKeyState = false
          this.apiSecretState = true
          this.impactState = false
          if (e.list.length) {
            this.merchantId = e.list[0].merchantId
            this.authKey = e.list[0].authKey
          } else {
            this.merchantId = ''
            this.authKey = ''
          }
        } else if (e.platformName == 'ShareASale') {
          this.apiTokenState = true
          this.authKeyState = false
          this.apiSecretState = true
          this.impactState = false
          if (e.list.length) {
            this.merchantId = e.list[0].merchantId
            this.apiSecret = e.list[0].apiSecret
            this.apiToken = e.list[0].apiToken
          } else {
            this.merchantId = ''
            this.apiSecret = ''
            this.apiToken = ''
          }
        } else {
          this.apiTokenState = false
          this.authKeyState = false
          this.apiSecretState = false
          this.impactState = true
          if (e.list.length) {
            this.merchantId = e.list[0].merchantId
            this.apiSecret = e.list[0].apiSecret
            this.impactAuthKey = e.list[0].authKey
          } else {
            this.merchantId = ''
            this.apiSecret = ''
            this.apiToken = ''
          }
        }
      }
    },
    handleError(e) {
      let str = new Image();
      str.src = e
      // e.currentTarget.src = "https://fc1tn.baidu.com/it/u=2119069989,971355091&fm=202&mola=new&crop=v1"
    },
    handleCloses() {
      this.drawer = false
      this.merchantId = ''
      this.authKey = ''
      this.apiToken = ''
      this.apiSecret = ''
      this.stutmsg = 0
    },
    // 授权
    testclick() {

      if (this.avtiStuts == 0) {
        if (!this.merchantId) {
          this.$message.error('merchantId不能为空')
          return
        }
        if (!this.authKey) {
          this.$message.error('authKey不能为空')
          return
        }
        this.showloading = true
        let data = {
          authType: this.platformCode,
          merchantId: this.merchantId,
          authKey: this.authKey
        }
        AUTH(data).then(res => {
          if (res.data.code == 'error') {
            this.$message.error(res.data.msg);
            this.stutmsg = 2
          } else {
            this.$message({
              message: '授权成功数据导入中，请30分钟后查看。',
              type: 'success'
            });
            this.$router.push({ path: './demo', query: { r: 7 } })
            this.queryPlatformListmap()
            this.merchantId = ''
            this.authKey = ''
            this.stutmsg = 1
            this.drawer = false
          }
          this.showloading = false
        })

      } else if (this.avtiStuts == 1) {
        if (!this.merchantId) {
          this.$message.error('merchantId不能为空')
          return
        }
        if (!this.apiToken) {
          this.$message.error('apiToken不能为空')
          return
        }
        if (!this.apiSecret) {
          this.$message.error('apiSecret不能为空')
          return
        }
        this.showloading = true
        let data = {
          authType: this.platformCode,
          merchantId: this.merchantId,
          apiToken: this.apiToken,
          apiSecret: this.apiSecret
        }
        AUTH(data).then(res => {
          if (res.data.code == 'error') {
            this.$message.error(res.data.msg);
            this.stutmsg = 2
          } else {
            this.$message({
              message: '授权成功数据导入中，请30分钟后查看。',
              type: 'success'
            });
            // this.queryPlatformListmap()
            // this.merchantId = ''
            // this.apiToken = ''
            // this.apiSecret = ''
            // this.stutmsg = 1
            // this.drawer = false
            this.$router.push({ path: './demo', query: { r: 7 } })
          }
          this.showloading = false
        })
      } else {
        if (!this.merchantId) {
          this.$message.error('merchantId不能为空')
          return
        }
        if (!this.impactAuthKey) {
          this.$message.error('apiToken不能为空')
          return
        }
        this.showloading = true
        let data = {
          authType: this.platformCode,
          merchantId: this.merchantId,
          authKey: this.impactAuthKey,
        }
        AUTH(data).then(res => {
          if (res.data.code == 'error') {
            this.$message.error(res.data.msg);
            this.stutmsg = 2
          } else {
            this.$message({
              message: '授权成功数据导入中，请30分钟后查看。',
              type: 'success'
            });
            this.$router.push({ path: './demo', query: { r: 7 } })
          }
          this.showloading = false
        })
      }
    },
    // 配置信息
    configure() {
      let routeUrl = this.$router.resolve({ path: 'configure', query: { type: this.platformName } });
      window.open(routeUrl.href, '_blank');
    }
  }
}
</script>
  
<style lang="less" scoped>
.co00ds {
  width: 100%;
  height: 100%;
  position: absolute;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  align-items: center;
  justify-content: center;
  color: #fff;
}

@import "../../assets/css/authorization/authorization.less";

.authorization {
  padding-top: 69px;
  // padding-left: 10%;
  box-sizing: border-box;
  background: #fafafa;
}

@media screen and (min-width: 1000px) and (max-width: 2000px) {
  .top_center {
    width: 1600px;
    margin: 0 auto;

  }
}

@media screen and (min-width: 2000px) and (max-width: 3000px) {
  .top_center {
    width: 1920px;
    margin: 0 auto;
  }
}

.top_center {
  height: 100vh;
}
</style>
<style lang="less">
.authorization {

  .el-drawer.ltr,
  .el-drawer.rtl {
    top: 69px;
  }
}
</style>